<template>
    <v-container fluid class="pa-0">
    <!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title class="ml-4 mr-4 mb-4" > <!--style="border-bottom: thin solid #FFB74D;"-->
            <v-icon>mdi-sheep</v-icon><span class="ml-2">Bétail / Animal</span>
            <v-spacer></v-spacer>
            <!--
            <v-btn depressed :color="(curentTab.substring(0,1) == '0' ) ? 'secondary' : ''" class="ml-1" @click="curentTab = '0';"><v-icon>mdi-information-variant-circle-outline</v-icon>Information</v-btn>
            <v-btn v-show="item.lst_id" depressed :color="(curentTab.substring(0,1) == '1' ) ? 'secondary' : ''" class="ml-1" @click="curentTab = '1';"><v-icon>mdi-bottle-tonic-plus-outline</v-icon>Santé</v-btn>
            <v-btn v-show="item.lst_id" depressed :color="(curentTab.substring(0,1) == '2' ) ? 'secondary' : ''" class="ml-1" @click="curentTab = '2';"><v-icon>mdi-map-search-outline</v-icon>Affectations</v-btn>
            <v-btn v-show="item.lst_id" depressed :color="(curentTab.substring(0,1) == '3' ) ? 'secondary' : ''" class="ml-1" @click="curentTab = '3';"><v-icon>mdi-file-document-multiple-outline</v-icon>Documents</v-btn>
            -->
            <v-tabs v-model="curentTab" grow light show-arrows="mobile">
                <v-tabs-slider color="green"></v-tabs-slider>
                <v-tab class="pl-1 pr-1"><v-icon class="mr-1">mdi-information-variant-circle-outline</v-icon><span class="hidden-sm-and-down">Information</span></v-tab>
                <v-tab v-show="item.lst_id" class="pl-1 pr-1"><v-icon class="mr-1">mdi-bottle-tonic-plus-outline</v-icon><span class="hidden-sm-and-down">Santé</span></v-tab>
                <v-tab v-show="item.lst_id" class="pl-1 pr-1"><v-icon class="mr-1">mdi-map-search-outline</v-icon><span class="hidden-sm-and-down">Affectations</span></v-tab>
                <v-tab v-show="item.lst_id" class="pl-1 pr-1"><v-icon class="mr-1">mdi-file-document-multiple-outline</v-icon><span class="hidden-sm-and-down">Documents</span></v-tab>
            </v-tabs>
        </v-card-title>

        <v-form ref="form" v-model="validForm" lazy-validation v-if="(curentTab == 0)">
        <!-- Identification -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field ref="lstTag" :rules="requiredRules" outlined dense class="rounded-lg" label="Numéro d'identification (Tag)" v-model="item.lst_tag" maxlength="36" @input="onTagInput"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-text-field :rules="nameRules" outlined dense class="rounded-lg" label="Nom" v-model="item.lst_name" maxlength="128"></v-text-field>
            </v-col>
        </v-row>
        <!-- Type et Race -->
        <v-row no-gutters>
            <v-col cols="12" md="4" class="pr-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['LST']" item-text="typ_name" item-value="typ_id" v-model="item.lst_typ_id" label="Espèce" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="px-2">
                
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['LTT']" item-text="typ_name" item-value="typ_id" v-model="item.lst_typ_id_spec" label="Type spécifique" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="pl-2">
                <v-text-field outlined dense class="rounded-lg" label="Race" v-model="item.lst_breed" maxlength="100"></v-text-field>
            </v-col>
        </v-row>
        <!-- Sexe et Statut -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-select :rules="requiredRules" outlined dense class="rounded-lg" label="Sexe" v-model="item.lst_sex" :items="sexItems"></v-select>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-select outlined dense class="rounded-lg" item-text="sta_label" item-value="sta_id" :items="stateListByGroup['LST']" v-model="item.lst_sta_id" label="Statut" single-line ></v-select>
            </v-col>
        </v-row>
        <!-- Dates -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field outlined dense class="rounded-lg" label="Date de naissance" v-model="item.lst_birth_date" type="date"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-text-field outlined dense class="rounded-lg" label="Date d'acquisition" v-model="item.lst_acquisition" type="date"></v-text-field>
            </v-col>
        </v-row>
        <!-- Parents -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field outlined dense class="rounded-lg" label="Tag du père" v-model="item.lst_tag_father" maxlength="36"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-text-field outlined dense class="rounded-lg" label="Tag de la mère" v-model="item.lst_tag_mother" maxlength="36"></v-text-field>
            </v-col>
        </v-row>
        <!-- Description -->
        <v-row no-gutters>
            <v-col cols="12">
                <v-textarea outlined dense class="rounded-lg" label="Description" v-model="item.lst_description" rows="2" maxlength="255"></v-textarea>
            </v-col>
        </v-row>
        <!-- Photo et Champs personnalisés -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-textarea outlined dense class="rounded-lg" label="Observations" v-model="item.lst_customfields.observation" rows="2"></v-textarea>
            </v-col>
        </v-row>
        </v-form>

        <HealthrecordTimeline v-if="curentTab == '1'"  :itemId="tabItemId" :switchTab="switchTab" :livestock="item" ></HealthrecordTimeline>
        <HealthrecordForm     v-if="curentTab == '11'" :itemId="tabItemId" :switchTab="switchTab" :livestock="item" ></HealthrecordForm>
        <AssignmentList       v-if="curentTab == '2'"  :itemId="tabItemId" :switchTab="switchTab" :livestockId="item.lst_id"></AssignmentList>
        <AssignmentForm       v-if="curentTab == '21'" :itemId="tabItemId" :switchTab="switchTab" :livestock="item"></AssignmentForm>
        <DocumentList         v-if="curentTab == '3'" :switchTab="switchTab" :doc_xxx_id="item.lst_id" :table_id="'lst'" 
            :routeState="{ siteView:false, siteEdit:true, view:false, edit:true, add:true, state: 'modifier' }" style="min-height: 474px;">
        </DocumentList>


        <v-card-actions v-if="curentTab == '0'">
            <v-btn class="rounded-xl" large color="red" v-if="item.lst_id" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl mr-2" large color="grey" :to="{ name: 'livestocks-list' }">Retour</v-btn>
            <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="(loading.fetchData || !validForm)">Enregistrer</v-btn>
        </v-card-actions>
    </v-card>
    </v-container>
</template>
   
<script>
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useLivestockStore } from '@/stores/livestock'

import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'

import DocumentList  from '@/components/documents/DocumentList.vue'
import HealthrecordTimeline  from '@/components/healthrecords/HealthrecordTimeline.vue'
import HealthrecordForm  from '@/components/healthrecords/HealthrecordForm.vue'
import AssignmentList  from '@/components/assignments/AssignmentList.vue'
import AssignmentForm  from '@/components/assignments/AssignmentForm.vue'

export default {
   name: 'livestocks-edit',
   components: { HealthrecordTimeline, HealthrecordForm, AssignmentList, AssignmentForm, DocumentList },
   computed: {
        ...mapWritableState(useLivestockStore, {item: 'item', correctedTag: 'correctedTag' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
   },
   watch: { },
   data: function () {
       return {
           loading: { fetchData: true },
           validForm: true,
           sexItems: [
               { text: 'Mâle', value: 'M' },
               { text: 'Femelle', value: 'F' }
           ],
           requiredRules: [ v => !!v || 'Le champ doit être renseigné' ],
           nameRules: [ v => !!v || 'Le champ doit être renseigné', v => (v && v.length <= 128) || 'Doit être inférieur à 128 caractères' ],
           curentTab: '0',
           tabItemId: null
       }
   },
   async mounted () {
        this.initItem()
        const lstId = this.$route.params.lst_id
        if (lstId && parseInt(lstId) > 0) {
            await this.fetchItem(lstId)
        } else if( this.$route.params.lst_tag && this.$route.params.lst_tag.length > 2 ){
            console.log(this.$route.params.lst_tag)
            this.item.lst_tag = this.$route.params.lst_tag
            await this.fetchItemByTag(this.$route.params.lst_tag)
        } else {
            this.initItem()
        }
        this.loading.fetchData = false
   },
   methods: {
        ...mapActions(useLivestockStore, {fetchItem: 'fetchItem', fetchItemByTag: 'fetchItemByTag', updateItem: 'updateItem', storeItem: 'storeItem', deleteItem: 'deleteItem', initItem: 'RESET_ITEM', formatTag: 'formatTag'}),
        async saveItem () {
            await this.$refs.form.validate()
            if( this.validForm ){
                // Enregistrement du formulaire
                this.loading.fetchData = true
                if( parseInt( this.item.lst_id ) > 0 ){
                    await this.updateItem()
                } else {
                    await this.storeItem()
                }
                if( this.$route.matched[1].name == 'dashboard' ){
                    this.$router.push({ name: this.$route.matched[1].name, params: {  } })
                } else {
                    this.$router.push({ path: '/livestocks' })
                }
            }
        },
        async onTagInput(value) {
            if (value && value.length >= 23) {
                await this.formatTag(value)
                this.item.lst_tag = (this.correctedTag[0]) ? this.correctedTag[0] : this.item.lst_tag
            }
        },
        switchTab(tab, id){
            console.log(tab, id)
            this.tabItemId = id || null
            if(tab){
                this.curentTab = tab
            }
            console.log(this.curentTab)
        },
   }
}
</script>